import React from 'react';
import styles from '../../static/css/pages.module.css';
import Header from "../../components/header/priv/header";
import Footer from "../../components/footer/footer";
import Button from "../../components/form/button/button";
import Icon from "../../components/icons/icons";
import ieSvg from "../../components/icons/ieSvg";
import ButtonCancel from "../../components/form/button/button_cancel";

class PageSuccess extends React.Component {

  componentDidMount() {
    document.title = "FBalance";
    ieSvg();
  }

  handleRedirect = () => {
    window.location.href = this.props.infoLink;
  }

  handleReload = () => {
    window.location.reload();
  }

  render() {
    return (
      <main>
        <Header type="pubinner"/>
        <section className={styles.section}>
          <div className="inner inner_small">
            <div className={`${styles.content} ${styles.simplepage}`}>
              <div>
                <div className="l-align_center">
                  <Icon name="icon_successpage" viewbox="0 0 227 120"/>
                  <div className={styles.title_page}>
                    {this.props.infoTitle}
                  </div>
                  <div className={styles.simplepage__info}>
                    {this.props.infoMessage}
                  </div>
                </div>
              </div>
              <div className={styles.simplepage__footer}>
                {
                  this.props.reloadButton ?
                    <ButtonCancel title={this.props.reloadButton} onClick={this.handleReload}/>
                    :
                    null
                }
                {
                  this.props.infoButton ?
                    <Button title={this.props.infoButton} onClick={this.handleRedirect}/>
                    :
                    null
                }
              </div>
            </div>
          </div>
        </section>
        <Footer type="pubinner"/>
      </main>
    )
  }
}

export default PageSuccess;